import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import Home from "./pages/Homepage";
import Download from "./pages/Download";
import Join from "./pages/Join";
import Terms from "./pages/Terms";
import Legal from "./pages/Legal";
import Announcements from "./pages/Announcements";
import DeleteAccount from "./pages/DeleteAccount";
import NotFound404 from "./pages/NotFound404";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";

function Layout() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Outlet />
    </>
  );
}

export default function App() {
  const router = createBrowserRouter([
    {
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/download",
          element: <Download />,
        },
        {
          path: "/join",
          element: <Join />,
        },
        {
          path: "/terms",
          element: <Terms />,
        },
        {
          path: "/legal",
          element: <Legal />,
        },
        {
          path: "/announcements",
          element: <Announcements />,
        },
        {
          path: "/delete-account",
          element: <DeleteAccount />,
        },
        {
          path: "*",
          element: <NotFound404 />,
        },
      ],
    },
  ]);
  return <RouterProvider router={router} />;
}
